module.exports = {
  cs: {
    default: true,
    path: `cs`,
    locale: `cs-CZ`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `cs`,
    ogLanguage: `cs-CZ`,
    defaultTitle: `Lavori | Stavební a montážní práce`,
    defaultDescription: `Stavební a instalační práce`,
  },
  en: {   
    path: `en`,
    locale: `en-US`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `en`,
    ogLanguage: `en_US`,
    defaultTitle: `Lavori | Construction and installation works`,
    defaultDescription: `Construction and installation works`,
  },
/*  
  ru: {
    path: `ru`,
    locale: `ru-RU`,
    dateFormat: `DD.MM.YYYY`,
    siteLanguage: `ru`,
    ogLanguage: `ru_RU`,
    defaultTitle: `Web solutions for you`,
    defaultDescription: `Web solutions for you`,
  }, */
  uk: {
    path: `uk`,
    locale: `uk-UA`,
    dateFormat: `DD.MM.YYYY`,
    siteLanguage: `uk`,
    ogLanguage: `uk_UA`,
    defaultTitle: `Lavori | Будівельні та інсталляційні роботи`,
    defaultDescription: `Будівельні та інсталляційні роботи`,
  },
}